import type { MessageAttachmentDto } from "@multi-chat/shared";
import { shouldRenderProviderAttachmentUrl } from "./attachment-media-display.js";
import { useStoredAttachmentUrl } from "./use-stored-attachment-url.js";

export function useInboxAttachmentUrl(
  organizationId: number,
  attachment: MessageAttachmentDto,
): {
  url: string | undefined;
  urlResolving: boolean;
  failed: boolean;
  refreshUrl: () => Promise<string | null>;
  ensureUrl: () => Promise<string | null>;
} {
  const stored = useStoredAttachmentUrl(organizationId, attachment);

  if (shouldRenderProviderAttachmentUrl(attachment)) {
    return {
      url: attachment.url,
      urlResolving: false,
      failed: false,
      refreshUrl: async () => attachment.url ?? null,
      ensureUrl: async () => attachment.url ?? null,
    };
  }

  if (attachment.storageState === "STORED") {
    return {
      url: stored.status === "ready" ? stored.url : undefined,
      urlResolving: stored.status === "loading" || stored.status === "idle",
      failed: stored.status === "error",
      refreshUrl: stored.refreshUrl,
      ensureUrl: stored.ensureUrl,
    };
  }

  return {
    url: undefined,
    urlResolving: attachment.storageState === "PENDING_STORAGE",
    failed:
      attachment.storageState === "UNAVAILABLE" ||
      attachment.storageState === "EXPIRED" ||
      attachment.storageState === undefined,
    refreshUrl: stored.refreshUrl,
    ensureUrl: stored.ensureUrl,
  };
}
